import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  size?: 'default' | 'large';
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  size = 'default',
  className = ''
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'py-5 px-8 text-lg md:text-xl' : 'py-4 px-6 text-base md:text-lg';
  return <button onClick={onClick} className={`
        w-full ${sizeClasses} font-bold text-white
        bg-pink-dark rounded-full
        shadow-[0_8px_24px_rgba(219,39,119,0.35)]
        hover:bg-[#be1f68] hover:shadow-[0_8px_30px_rgba(219,39,119,0.45)]
        active:scale-[0.98]
        transition-all duration-200 ease-out
        cursor-pointer
        font-body
        ${className}
      `} aria-label={typeof children === 'string' ? children : undefined} data-id="element-36">
      {children}
    </button>;
}